import { exponentOf } from "@tripcart/shared/format";
// Subpath on purpose: the zod-free half of the contract (no zod in the browser).
import {
  ADS_EVENT_NAME,
  ADS_EVENT_QUEUE_GLOBAL,
  type AdsStorefrontEvent,
} from "@tripcart/shared/apps/ads-storefront";

/**
 * Reports a traveler moment to the Meta Ads and Google Ads apps. It only
 * queues the moment: each app's inline script (`APP_REGISTRY["meta-ads"]`,
 * `["google-ads"]`) decides whether and when to send it — installed, event
 * switched on, consent given. With neither app installed nothing reads the
 * queue, so this costs one array push.
 */
export function trackAdsEvent(event: AdsStorefrontEvent): void {
  const w = window as unknown as Record<string, unknown>;
  const queue = (w[ADS_EVENT_QUEUE_GLOBAL] ??= []) as AdsStorefrontEvent[];
  queue.push(event);
  window.dispatchEvent(new Event(ADS_EVENT_NAME));
}

/** Integer minor units → the major-unit number Meta and Google expect. */
export function adsValue(amountMinor: number, currency: string): number {
  return amountMinor / 10 ** exponentOf(currency);
}
